import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
} from "react";
import { getRegisterlist } from "./../../services/wms";
import Headerqueue from "./headerqueue";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import moment from "moment";
import BranchContext from "./../context/branch";
import Input from "./../wms/input";
import Renderqueue from "./renderqueue";
import ScrollToTop from "../common/ScrollToTop";
import ModalSearchprofile from "../common/searchcustomer";
import { toast } from "react-toastify";
import Confirmcall from "./confirmcall";
import {
  GetdataQueueCall,
  savebooking,
} from "./../../services/wms/grabconcept";

const CardQueueCall = (props) => {
  let datalink = props.location.linkdetails;
  let cusId = 0;
  //console.log(datalink);
  if (datalink) {
    cusId = datalink.cusid;
  }
  //console.log(cusId);http://wms.advanceagro.net/wsface/api/face/RealImage?IdentityID=

  const { currentBranch } = useContext(BranchContext);

  //const [register, setregister] = useState([]);
  const [isOpenf, setisOpenf] = useState("");
  const [cusid, setCusid] = useState(cusId);
  const [search, setSearch] = useState("");
  const [name, setname] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [vForm, setvForm] = useState(false);
  const [endDate, setEndDate] = useState(new Date());
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [QueueCall, setQueueCall] = useState([]);
  const [message, setmessage] = useState("ยืนยันเรียกคิว");
  const [askConfirm, setaskConfirm] = useState(false);
  const [statusId, setstatusId] = useState("1");
  const [total, settotal] = useState(0);
  const [data, setdata] = useState([]);
  const [reload, setreload] = useState([]);

  useEffect(() => {
    if (vForm) return;
    const getLinkdata = () => {
      if (datalink && !vForm) {
        const queuedate = new Date(datalink.ddate);
        setvForm(true);
        setStartDate(queuedate);
        setEndDate(queuedate);
        setCusid(datalink.cusid);
      } else {
        setvForm(true);
      }
    };
    getLinkdata();
  });
  const handleChangreload = (event) => {
    setreload(event);
  };


  const handlecallChange = (event) => {
    setstatusId(event);
  };
  useEffect(() => {
    setQueueCall([]);
  }, [
    vForm,
    startDate,
    statusId,
    endDate,
    currentBranch,
    search,
    cusid,
    pageSize,
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id == "") return;

    const loadData = async () => {
      const { data: result } = await GetdataQueueCall(
        moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
        currentBranch._id,
        statusId,
        pageSize,
        pageNumber,
        search
      );

      if (result.status === "success") {
        settotal(result.data.total);
        setdata(result.data.list);

        setdata((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
      }
    };
    loadData();
  }, [
    currentBranch,
    statusId,
    startDate,
    endDate,
    pageSize,
    pageNumber,
    search,
    reload,
  ]);

  useEffect(() => {
    if (!currentBranch) return;
    setLoading(true);
    setError(false);

    const loadData = async () => {
      const { data: result } = await GetdataQueueCall(
        moment(startDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
        moment(endDate, "YYYY-MM-DD").add(0, "day").format("YYYY-MM-DD"),
        "505",
        "1",
        pageSize,
        pageNumber,
        search
      );

      if (result.status === "success") {
        setQueueCall((prevData) => {
          return [...new Set([...prevData, ...result.data.list])];
        });
        setHasMore(result.data.list.length > pageSize - 1);
        setLoading(false);
        // console.log("test",QueueCall);
      }
    };
    loadData();
  }, [
    vForm,
    startDate,
    endDate,
    currentBranch,
    search,
    pageSize,
    pageNumber,
    search,
    reload,
  ]);

  const handleChangStartDate = (event) => {
    setStartDate(event);
    setPageNumber(1);
  };
  const handleChangEndDate = (event) => {
    setEndDate(event);
    setPageNumber(1);
  };
  const observer = useRef();
  const lastBookElementRef = useCallback(
    (node) => {
      // console.log('node = ' ,node);
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        //  console.log(entries[0].isIntersecting,hasMore);

        if (entries[0].isIntersecting && hasMore) {
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  const handleTextchange = (event) => {
    //console.log("bb",name)
    setname(event.target.value);
    // setPageNumber(1);
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      //console.log("bb",name)
      setSearch(name);
      setPageNumber(1);
    }
  };
  const handleSearchDrinvenClick = () => {
    //console.log("cc",name)
    setSearch(name);
    setPageNumber(1);
  };
  const handleConfirmSubmitcall = (even) => {
  
    doSubmit(even);
    //setaskConfirm(false);
  };
  const doSubmit = async (id) => {
    try {
      const doc = {
        statusid: 3,
        id: id,
      };

      const { data: result } = await savebooking(doc);
      // console.log('doc',doc);
      if (result === true) {
        toast.success("บันทึกเสร็จเรียบร้อย");

        const urlGoBack = "/CardQueueCall/";
        setTimeout(props.history.replace(urlGoBack), 1000);
      } else if (result === false) {
        toast.success("ไม่พบ");
      }
    } catch (err) {
      toast.error("Error");
    }
  };

  //console.log(currentBranch._id);
  //console.log(register);
  if (!vForm) {
    return <div></div>;
  }
  if (currentBranch._id == "vms") {
    return <></>;
  }

  return (
    <>
      <div className=" btn-success d-flex justify-content-center  ">
        <span className="m-1" style={{ fontSize: 20 }}>
          ตารางเรียกคิว
        </span>
      </div>

      <div className="row">
        <div className="col-lg-3 col-sm-6 col-md-3 col-xs-3 m-4">
          <div className="form-group">
            {/* <ModalSearchprofile
          isOpen={openModalSearch}
          header={"ข้อมูลผู้ขาย/ลูกค้า"}
          //search={custName}
          //list = {customer}
          onCancel={handleCancleSubmit}
          onSelect={handleConfirmSubmittruck}
        /> */}
            <Input
              name="weightno"
              value={name}
              placeholder="ทะเบียนรถ เลขที่ใบชั่ง"
              onChange={handleTextchange}
              onKeyPress={handleKeyPress}
              onClick={handleSearchDrinvenClick}
              search="ค้นหา"
            />
          </div>
        </div>
        <div className="col-auto">
          <div className="m-2">
           <i>
              จากวันที่ 
            </i>

            <div className="mt-2" style={{ marginTop: 20, marginBottom: 20 }}>
              <DatePicker
 className="datepicker-default form-control"
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                onChange={handleChangStartDate}
              />
            </div>
          </div>
        </div>
        <div className="col-auto">
          <div className="m-2">
           <i>
              ถึงวันที่ 
            </i>
            <div className="mt-2">
              <DatePicker
 className="datepicker-default form-control"
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={endDate}
                onChange={handleChangEndDate}
              />
            </div>
          </div>
        </div>
        {/*             
            <div className="col-lg-6 col-sm-6 col-md-6 col-xs-12">
            <div>&nbsp;</div>
              <button className="btn btn-success ">Download To Excel</button>
            </div> */}

        {/* //<div className="col-lg-3 col-sm-6 col-md-3 col-xs-3 m-5">
             //<div className="form-group"> */}

        <div className="col-auto mt-2">
         <i>
            ประเภท 
          </i>
          <div className="mt-2 " style={{ marginTop: 20, marginBottom: 20 }}>
            <Headerqueue onChange={handlecallChange} />
          </div>
        </div>

        {/* //</div>  */}

        {/* <div className="mt-2 " style={{ marginTop: 20, marginBottom: 20 }}>
            
            <Header onChange={handleReportChange} />
          
        </div> */}

        {/* //</div> */}
      </div>
      <p className="text-success">
        แสดงข้อมูล {data ? data.length : 0} รายการ บนระบบ
      </p>
      {<ScrollToTop />}

      <Renderqueue
        list={data}
        loading={loading}
        error={error}
        lastBookElementRef={lastBookElementRef}
        reload={handleChangreload}
        handleConfirmSubmitcall={handleConfirmSubmitcall}
      />

      <div>{loading && "Loading..."}</div>
      <div>{error && "Error"}</div>
    </>
  );
};

export default CardQueueCall;
